import { BaseApi } from './base.api.js';
import { ApiError } from '../errors/api-error.js';

export class DisposalApi extends BaseApi {
    constructor(client) {
        super(client, '/disposal-run');
    }

    async getRecords(id) {
        try {
            const response = await this.client.get(`${this.basePath}/${id}/records`);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async addRecord(id, data) {
        try {
            const response = await this.client.post(`${this.basePath}/${id}/records`, data);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async complete(id, data = {}) {
        try {
            const response = await this.client.post(`${this.basePath}/${id}/complete`, data);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    /** İmha tutanağı (HTML blob). */
    async getReport(id) {
        try {
            const response = await this.client.get(`${this.basePath}/${id}/report`, { responseType: 'blob' });
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    /** Saklama ve imha politikası taslağı (HTML blob). */
    async getPolicyDocument() {
        try {
            const response = await this.client.get(`${this.basePath}/policy-document`, { responseType: 'blob' });
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }
}
